import apiClient from "../helpers/apiClient";
import ImageCompressor from "./ImageCompressor";

const compressFile = async (file) => {
    const imageTypes = ["image/jpeg", "image/jpg", "image/png", "image/gif", "image/webp", "image/avif"];

    // Compress images using browser-image-compression
    if (imageTypes.includes(file.type)) {
        try {
            return await ImageCompressor(file, 0.5);
        } catch (error) {
            // eslint-disable-next-line no-console
            console.warn("Image compression failed, using original file:", error);
            return file;
        }
    }

    // Return original file if compression is not available or not beneficial
    return file;
};

const uploadFile = async (file, folder) => {
    if (!file) {
        return undefined;
    }

    const compressedFile = await compressFile(file);

    const formData = new FormData();
    formData.append("file", compressedFile, compressedFile.name);
    if (folder) {
        formData.append("folder", folder);
    }

    try {
        const response = await apiClient.post("/api/upload", formData);
        return response.data?.data?.downloadURL;
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Error uploading file:", error);
        throw error;
    }
};

export default uploadFile;
